<div class="modal-header">
    <h2 class="modal-header__title">
        {{title}}
    </h2>
    <div class="modal-header__close-link">
        <span class="close" [mat-dialog-close]></span>
    </div>
</div>
<div class="modal-content">
    <ng-content></ng-content>
</div>
